export enum AddressType {
  Billing = 'Billing',
  Home = 'Home',
  Office = 'Office',
  Shipping = 'Shipping',
}

export enum AreaUnits {
  SqFt = 'SqFt',
  Acres = 'Acres',
}

export enum AssignmentPriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
}

export enum AssignmentSourceType {
  FeedItem = 'FeedItem',
  BrokeragePipeline = 'BrokeragePipeline',
}

export enum AssignmentStatus {
  All = 'All',
  Complete = 'Complete',
  Incomplete = 'Incomplete',
}

export enum AttachmentType {
  Document = 'Document',
  MainPhoto = 'MainPhoto',
  NotSpecified = 'NotSpecified',
  Photo = 'Photo',
  Video = 'Video',
}

export enum BuildingClass {
  NotApplicable = 'NotApplicable',
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum CalendarEventType {
  General = 'General',
  Assignment = 'Assignment',
  Listing = 'Listing',
  BrokeragePipeline = 'BrokeragePipeline',
  DueDiligence = 'DueDiligence',
}

export enum CityProfileSpecialFileType {
  RetailNodeMap = 'RetailNodeMap',
  RegionalMap = 'RegionalMap',
  CompetitorsMap = 'CompetitorsMap',
  TrafficCountMap = 'TrafficCountMap',
  TopBrokers = 'TopBrokers',
  ChamberOfCommerceFile = 'ChamberOfCommerceFile',
}

export enum Corridor {
  NotApplicable = 'NotApplicable',
  Interior = 'Interior',
  Exterior = 'Exterior',
}

export enum DateRange {
  AllTime = 'AllTime',
  LastDay = 'LastDay',
  LastWeek = 'LastWeek',
  LastMonth = 'LastMonth',
  LastSixMonths = 'LastSixMonths',
}

export enum DevelopmentPipelineType {
  Potential = 'Potential',
  Pending = 'Pending',
  Active = 'Active',
  Completed = 'Completed',
}

export enum DevelopmentSiteStatus {
  Potential = 'Potential',
  Pending = 'Pending',
  Active = 'Active',
  Completed = 'Completed',
}

export enum DueDiligenceItemResponsibility {
  Buyer = 'Buyer',
  Seller = 'Seller',
  Tenant = 'Tenant',
  Both = 'Both',
}

export enum DueDiligenceItemType {
  CheckOff = 'CheckOff',
  Date = 'Date',
  Document = 'Document',
  EarnestMoney = 'EarnestMoney',
  TagConnections = 'TagConnections',
}

export enum EmailType {
  Personal = 'Personal',
  Primary = 'Primary',
  Work = 'Work',
}

export enum EntityAccessType {
  Property = 'Property',
  Contact = 'Contact',
  Role = 'Role',
  Team = 'Team',
  Listing = 'Listing',
  DevelopmentSite = 'DevelopmentSite',
  DevelopmentClient = 'DevelopmentClient',
}

export enum EntityAccessValue {
  ViewOnly = 'ViewOnly',
  OwnAttachments = 'OwnAttachments',
  Edit = 'Edit',
  Unrestricted = 'Unrestricted',
}

export enum FeedItemSourceType {
  Contact = 'Contact',
  Property = 'Property',
  Team = 'Team',
  Assignment = 'Assignment',
  DevelopmentSite = 'DevelopmentSite',
}

export enum FeedItemType {
  Post = 'Post',
  Lead = 'Lead',
  Attachment = 'Attachment',
  Assignment = 'Assignment',
}

export enum ImageSize {
  h100w100 = 'h100w100',
  h100w150 = 'h100w150',
  h200w250 = 'h200w250',
  h500 = 'h500',
  h500w500 = 'h500w500',
  h50w50 = 'h50w50',
  h75w100 = 'h75w100',
  original = 'original',
  w500 = 'w500',
  w750 = 'w750',
}

export enum LandingPageOption {
  Assignments = 'Assignments',
  Companies = 'Companies',
  Connections = 'Connections',
  Home = 'Home',
  LastPage = 'LastPage',
  Leads = 'Leads',
  Listings = 'Listings',
  Pipeline = 'Pipeline',
  Properties = 'Properties',
  SuccessStories = 'SuccessStories',
}

export enum LeadPriority {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export enum LeadType {
  Other = 'Other',
  BuyerInvestor = 'BuyerInvestor',
  BuyerUser = 'BuyerUser',
  DevelopmentClient = 'DevelopmentClient',
  Seller = 'Seller',
  Tenant = 'Tenant',
}

export enum ListingStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Pending = 'Pending',
  Sold = 'Sold',
}

export enum ListingProgressV2Status {
  Incomplete = 'Incomplete',
  Complete = 'Complete',
  Ignore = 'Ignore',
}

export enum ListingType {
  Development = 'Development',
  Lease = 'Lease',
  Sale = 'Sale',
  Invoice = 'Invoice',
}

export enum MembershipType {
  Role = 'Role',
  Team = 'Team',
}

export enum NotificationContext {
  All = 'All',
  Calendar = 'Calendar',
  Standard = 'Standard',
}

export enum NotificationSourceType {
  Assignment = 'Assignment',
  ChatMention = 'ChatMention',
  Comment = 'Comment',
  DueDiligenceItem = 'DueDiligenceItem',
  Favorite = 'Favorite',
  Lead = 'Lead',
  Message = 'Message',
  Post = 'Post',
  SiteSuggestion = 'SiteSuggestion',
}

export enum PermissionLevel {
  Deny = -1,
  Inherit = 0,
  Allow = 1,
}

export enum PhoneType {
  Mobile = 'Mobile',
  OfficeMain = 'OfficeMain',
  Home = 'Home',
  Fax = 'Fax',
  OfficeDirect = 'OfficeDirect',
}

export enum PipelineStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
}

export enum PreferenceKeys {
  LandingPage = 'landingPage',
  LastPage = 'lastPage',
}

export enum PriceUnits {
  PricePerAcre = 'PricePerAcre',
  PricePerSqFt = 'PricePerSqFt',
  Total = 'Total',
}

export enum PropertyType {
  Office = 'Office',
  Industrial = 'Industrial',
  Retail = 'Retail',
  HealthCare = 'HealthCare',
  Multifamily = 'Multifamily',
  Land = 'Land',
  AgriculturalLand = 'AgriculturalLand',
  HotelAndMotel = 'HotelAndMotel',
  SeniorHousing = 'SeniorHousing',
  SportAndEntertainment = 'SportAndEntertainment',
  SpecialPurpose = 'SpecialPurpose',
  ResidentialIncome = 'ResidentialIncome',
  RecreationalLand = 'RecreationalLand',
}

export enum ReferralFilter {
  All = 'All',
  Referral = 'Referral',
  NoReferral = 'NoReferral',
}

export enum RelatedFileSource {
  Property = 'Property',
}

export enum ReminderPeriod {
  Days = 'Days',
  Weeks = 'Weeks',
}

export enum ReminderStatus {
  Unsent = 'Unsent',
  Sent = 'Sent',
}

export enum RentalRateUnits {
  PerMonth = 'PerMonth',
  PerSqFtPerMonth = 'PerSqFtPerMonth',
  PerSqFtPerYear = 'PerSqFtPerYear',
  PerYear = 'PerYear',
}

export enum ShareContactType {
  Contact = 'Contact',
  Group = 'Group',
}

export enum SignTranferStatus {
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  Incomplete = 'Incomplete',
}

export enum SiteSuggestionStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Denied = 'Denied',
}

export enum SoldPropertiesSortOption {
  ClosingDate = 'ClosingDate',
  DaysOnMarket = 'DaysOnMarket',
  DaysOnMarketDesc = 'DaysOnMarketDesc',
  DaysToClose = 'DaysToClose',
  DaysToCloseDesc = 'DaysToCloseDesc',
}
